export const MAX_DECK_PASSIVE_ID_LENGTH = 128;
const DECK_PASSIVE_ID_PATTERN = /^[a-z0-9]+(?:_[a-z0-9]+)*$/u;
/** Shared authoring/wire/persistence shape for stable deck-passive ids. */
export function isDeckPassiveId(value) {
    return typeof value === 'string'
        && value.length <= MAX_DECK_PASSIVE_ID_LENGTH
        && DECK_PASSIVE_ID_PATTERN.test(value);
}
export function assertDeckPassiveId(value, where = 'DeckPassiveId') {
    if (!isDeckPassiveId(value)) {
        throw new Error(`${where} должен быть stable lowercase id длиной 1..${MAX_DECK_PASSIVE_ID_LENGTH}`);
    }
    return value;
}
//# sourceMappingURL=deck-passive-id.js.map